// extracted by mini-css-extract-plugin
export default {"form":"AddRequestProjectForm_form__Tv7Iy","title":"AddRequestProjectForm_title__+iwk3","buttonWrapper":"AddRequestProjectForm_buttonWrapper__jKIdm"};